/**
 * @flow
 * */
import riskWeeklyReportController from './core/controllers/RiskWeeklyReportController';
import riskWeeklyConfigController from './core/controllers/RiskWeeklyConfigController';
import riskWeekly from './store/reducers';
import ROUTES from './routes';

/**
 * Standalone Risk Weekly Report module.
 *
 * Registered at the root store as RISK_WEEKLY_REPORT rather than under a product slice, since
 * the report reads across SRMT, CRMT and GRMT data and belongs to none of them.
 */

/**
 * getProjectState
 * @param {Object} state - root state
 * @returns {Object} module slice
 */
const getProjectState = (state: Object) => state.RISK_WEEKLY_REPORT;

const routes = [...ROUTES];

const controllers = [
  riskWeeklyReportController(),
  riskWeeklyConfigController()
];

// A single slice, so the module's reducer IS the feature reducer — no combineReducers needed.
const reducers = riskWeekly;

export {
  getProjectState,
  controllers,
  reducers,
  routes
};
